export const buttonStyles = {
  background: "#3671E9",
  color: "#ffffff",
  textTransform: "none",
  borderRadius: "2rem",
  padding: ".75rem 2rem",
  ":hover": {
    background: "#3671E9",
    transform: "scale(1.05)",
    transition: ".5s",
  },
};

export const navLinkItemStyle = {
  cursor: "pointer",
  ":hover": {
    borderBottom: ".25rem solid #ffffff",
    paddingBottom: ".5rem",
    transition: ".5s",
  },
};

export const loginLinkStyles = {
  borderRight: ".063rem solid rgba(242, 242, 242, .3)",
  cursor: "pointer",
  ":hover": {
    opacity: ".5",
    transition: ".5s",
  },
};

export const navbarWrapperStyles = {
  background: "#0F054C",
  color: "#ffffff",
  padding: "3rem 6rem",
};
